import React from 'react'

import { Comment } from 'services/apiTypes/comment.types'

import styles from './flair.module.scss'

type Props = { comment: Comment }

// The keys for these come from the frame file names
// If we ever either add more frames, or change their names we'll have to update this map
// If they're not found in this map, just return null and don't show the flair
const FILE_TO_FLAIR: Record<string, React.ReactNode> = {
  'alpha': 'Alpha User',
  'common': 'Common Patron',
  'uncommon': 'Uncommon Patron',
  'rare': 'Rare Patron',
  'mythic': 'Mythic Patron',
  'masterpiece': 'Masterpiece Patron',
  'moderator': 'Archidekt Moderator',
}

const frameToFlair = (frame?: string) => {
  if (!frame) return null

  const frameURLParts = frame.split('/')
  const suffix = frameURLParts[frameURLParts.length - 1]

  for (const fileName of Object.keys(FILE_TO_FLAIR)) {
    if (suffix.startsWith(fileName)) return FILE_TO_FLAIR[fileName]
  }

  return null
}

const CommentFlair = ({ comment }: Props) => {
  const flairByFrame = frameToFlair(comment.owner.frame)

  if (!flairByFrame) return null

  return <div className={styles.flair}>({flairByFrame})</div>
}

export default CommentFlair
